module.exports = __webpack_public_path__ + "img/ycg_snb.f02fb7a0.svg";